import { render } from "./GoalReference.vue?vue&type=template&id=3691af05&scoped=true"
import script from "./GoalReference.vue?vue&type=script&lang=js"
export * from "./GoalReference.vue?vue&type=script&lang=js"

import "./GoalReference.vue?vue&type=style&index=0&id=3691af05&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3691af05"]])

export default __exports__